import { useEffect, useState } from "react";

import { useMsal } from "@azure/msal-react";

interface UserData {
  displayName: string;
  givenName: string;
  surname: string;
  mail: string;
  userPrincipalName: string;
}

export const useGetTeamsUserData = (loginRequest: any) => {
  const { instance, accounts } = useMsal();
  const [userData, setUserData] = useState<UserData | null>(null);
  const [userPhotoUrl, setUserPhotoUrl] = useState<string | null>(null);
  const [loading, setLoading] = useState<boolean>(false);
  const [error, setError] = useState<Error | null>(null);

  useEffect(() => {
    const fetchUserData = async () => {
      if (!accounts || accounts.length === 0) return;

      setLoading(true);
      try {
        const response = await instance.acquireTokenSilent({
          ...loginRequest,
          account: accounts[0],
        });

        const graphRes = await fetch("https://graph.microsoft.com/v1.0/me", {
          headers: {
            Authorization: `Bearer ${response.accessToken}`,
          },
        });

        if (!graphRes.ok) throw new Error("Failed to fetch user data");

        const data = await graphRes.json();
        setUserData(data);

        const photoRes = await fetch("https://graph.microsoft.com/v1.0/me/photo/$value", {
          headers: {
            Authorization: `Bearer ${response.accessToken}`,
          },
        });

        if (photoRes.ok) {
          const blob = await photoRes.blob();
          const photoUrl = URL.createObjectURL(blob);
          setUserPhotoUrl(photoUrl);
        } else {
          console.warn("Failed to get user image.");
        }
      } catch (err) {
        console.error("Error fetching user data:", err);
        setError(err as Error);
      } finally {
        setLoading(false);
      }
    };

    fetchUserData();
  }, [instance, accounts]);

  return { userData, userPhotoUrl, loading, error };
};
